import { ProjectId } from 'api/models';
import { byLabel } from 'utils/comparators/by-label';
import { fullName } from 'utils/full-name';
import { getRandomColor } from 'utils/get-random-color';
import { OptionGroup } from '../components/organisms/field-editors/components/controlled-select-based-editor-popover';
import { useInAndNotInProjectUsers } from './use-assignee-options';
import { useTranslate } from './use-translation';

export const useUserFieldOptions = ({
  projectId,
  isPrivate = false,
}: {
  projectId: ProjectId;
  isPrivate?: boolean;
}): OptionGroup[] => {
  const translate = useTranslate();
  const {
    inProjectUsers: usersInProject,
    notInProjectUsers: usersNotInProject,
  } = useInAndNotInProjectUsers({
    projectId,
    isPrivate,
  });

  return [
    {
      label: translate('users'),
      options: usersInProject
        .map((u) => ({
          value: u.userId,
          label: fullName(u),
          imageUrl: u.photoUrl,
          description: u.role?.roleName,
          color: getRandomColor(u.userId),
        }))
        .sort(byLabel),
    },
    {
      label: translate('not_in_project'),
      options: usersNotInProject
        .map((u) => ({
          value: u.userId,
          label: fullName(u),
          imageUrl: u.photoUrl,
          description: u.role?.roleName,
          color: getRandomColor(u.userId),
        }))
        .sort(byLabel),
    },
  ];
};
